import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import styled from "styled-components";

const formatter = (val) => {
  return Math.abs(val) > 999999999
    ? `₦ ${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
    : Math.abs(val) > 999999
    ? `₦${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
    : Math.abs(val) > 999
    ? `₦${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
    : Math.sign(val) * Math.abs(val);
};
const CustomTooltip = ({ active, payload, label }) => {
  return (
    <div
      style={{ background: "#e7e7e7", borderRadius: "10px", padding: "10px" }}
      className="custom-tooltip"
    >
      <h2 className="label">{`${label}`}</h2>
      <p>
        Inbound:{" "}
        <span style={{ color: payload[0]?.stroke }}>
          {formatter(payload[0]?.value)}
        </span>
      </p>
      <p>
        Outbound:{" "}
        <span style={{ color: payload[1]?.stroke }}>
          {formatter(payload[1]?.value)}
        </span>
      </p>
    </div>
  );
};
const LineChartExample = ({ chartData }) => {
  return (
    <Chart>
      <ResponsiveContainer className="chart" width="100%" aspect={2.6}>
        <LineChart
          width={500}
          height={300}
          data={
            chartData || [
              {
                institution: "Null",
                inboundTransaction: 0,
                outboundTransaction: 0,
              },
            ]
          }
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="institution" />
          <YAxis
            axisLine="none"
            tickFormatter={function (val) {
              return Math.abs(val) > 999999999
                ? `${Math.sign(val) * (Math.abs(val) / 1000000000).toFixed(1)}B`
                : Math.abs(val) > 999999
                ? `${Math.sign(val) * (Math.abs(val) / 1000000).toFixed(1)}M`
                : Math.abs(val) > 999
                ? `${Math.sign(val) * (Math.abs(val) / 1000).toFixed(1)}k`
                : Math.sign(val) * Math.abs(val);
            }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Line
            type="monotone"
            dataKey="totalInbound"
            stroke="#FF993A"
            strokeDasharray="10 10"
            strokeWidth={2}
          />
          <Line
            type="monotone"
            dataKey="totalOutbound"
            stroke="#04A3E5"
            strokeDasharray="10 10"
            strokeWidth={2}
          />
        </LineChart>
      </ResponsiveContainer>
    </Chart>
  );
};

const Chart = styled.div`
  .chart {
    font-size: 10px;
    margin-left: -20px;
  }
`;

export default LineChartExample;

// <TransactionAnalysis>
// <div className="inner">
//   <div className="star">
//     <h3>Transaction Analysis</h3>
//     <AiOutlineStar size={20} />
//   </div>
//   <div className="bank">
//     <span>Fideliy Bank</span>
//     <span>Gtb Bank</span>
//     <span>Hopes Bank</span>
//     <span>Access Bank</span>
//     <span>First Bank</span>
//     {/* <span>Polaris Bank</span> */}
//     <span>Eco Bank</span>
//     <span>Access Bank</span>
//   </div>
//   <div style={{ paddingTop: "20px" }}>
//     <Analysis />
//   </div>
// </div>
// </TransactionAnalysis>
